import { GetRingVideoShareUrlQuery } from '@amzn/ring-neighbors-api-orchestrator-gql-schema';
import GET_VIDEO_SHARE_URL from '@amzn/ring-neighbors-api-orchestrator-gql-schema/operations/authenticated/video/getRingVideoShareUrl.graphql';
import { useLazyQuery } from '@apollo/client';

export const useGetVideoShareUrl = () =>
  useLazyQuery<GetRingVideoShareUrlQuery>(GET_VIDEO_SHARE_URL, {
    fetchPolicy: 'network-only',
  });
